import { Box } from '@chakra-ui/react'
import React from 'react'

export const Container = ({ children, ...props }) => (
  <Box maxW={1280} mx="auto" p="1rem" {...props}>
    {children}
  </Box>
)